import type { PreparationCloseoutEventData } from '../../../types'

type Params = {
  driverId: string
  extRoute?: uui.domain.client.rm.ExtendedRoute
  arrivalDepot: string
  lastDriverId: string
  approvedRoute?: uui.domain.client.rm.SchedulerRowApprovedData
  routeTrackingData?: uui.domain.client.rm.RouteTrackingData['routeTrackingData']
}
export function computeCloseoutTimeEntry({
  extRoute,
  driverId,
  lastDriverId,
  arrivalDepot,
  approvedRoute,
  routeTrackingData,
}: Params): PreparationCloseoutEventData | undefined {
  // If there are no routeTrackingData and the driver is not the last one just bail-out
  if (!routeTrackingData && driverId !== lastDriverId) return

  // Check if got tracking data
  const gotTrackingData =
    routeTrackingData &&
    (routeTrackingData.closeOutTrackingData.timeInSec !== -1 ||
      routeTrackingData.closeOutTrackingData.timeOutSec !== -1)

  // If got tracking data and the driver is not the same who tracked the event just bail-out
  if (gotTrackingData && routeTrackingData.closeOutTrackingData.driverId !== driverId) return

  // Compose tracking data
  const tracked = gotTrackingData
    ? {
        location: routeTrackingData.closeOutTrackingData.timeInLatLng
          ? routeTrackingData.closeOutTrackingData.timeInLatLng
          : undefined,
        start: routeTrackingData.closeOutTrackingData.timeInSec,
        end: routeTrackingData.closeOutTrackingData.timeOutSec,
      }
    : undefined

  // Search for the matching step on the approved version
  for (const extRouteStep of approvedRoute?.steps ?? []) {
    if (extRouteStep.type !== 'closeOut') continue

    // Compose planned data
    const planned = {
      location: arrivalDepot,
      start: extRouteStep.startSec,
      end: extRouteStep.endSec,
    }

    // If there are some tracking data return the 'complete' version
    if (tracked) {
      return {
        type: 'complete',
        planned,
        tracked,
      }
    }

    return {
      type: 'planned-only',
      planned,
    }
  }

  // If we have tracked let's return them
  if (tracked) {
    return {
      type: 'tracked-only',
      tracked,
    }
  }

  // If no matching step has been found on the approved version and no tracked data are present
  // let's check if the current version got a closeOut step
  for (const aggregatedStep of extRoute?.steps ?? []) {
    for (const extRouteStep of aggregatedStep.steps) {
      if (extRouteStep.step.type !== 'closeOut') continue

      return {
        type: 'tracked-only',
        tracked: {
          start: -1,
          end: -1,
        },
      }
    }
  }
}
